import state from './moduleShopifyState.js'
import mutations from './moduleShopifyMutations.js'
import actions from './moduleShopifyActions.js'
import getters from './moduleShopifyGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
